import {
    RxDocument,
    RxJsonSchema
  } from 'rxdb';
  import { Route } from '../models';
  
  export type RouteDoc = RxDocument<Route, {}>
  
  export const routeSchema: RxJsonSchema<Route> = {
    title: 'route schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        id: {
            type: 'string',
            primary: true
        },
        market: { type: ['string', 'null'] },
        county: { type: ['string', 'null'] },
        length: { type: ['number', 'null'] },
        updatedAt: { type: 'number' }  
    },
    required: ['id'],
    indexes: [ 'updatedAt']
  };
  
  
  
  export const routePullQueryBuilder = () => {
    return (doc) => {
        if (!doc) {
            doc = {
                id: '',
                market: '',
                county:'',
                length: '',
                updatedAt: 0, 
                deleted: false 
            }
        }
  
        const query = `{ feedForRxdbRoutes(lastId: "${doc.id}", minUpdatedAt: ${doc.updatedAt}){ 
                id
                market
                county
                length
                updatedAt
                deleted
                _rev
         } }`;
        return {
            query,
            variables: {}
        };
    };
  };
  
  
  //Need to have shared schema with server for this to work
  export const graphQLGenerationInput = {
    allPoints: {
        schema: routeSchema,
        feedKeys: [
            '_id',
            'routeId',
            'updatedAt'
        ],
        deletedFlag: 'deleted'
    }
  }